import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import ChannelInterface from "@/interfaces/channel.interface";

const channels = ref<ChannelInterface[]>([]);

export default function useChannels() {
    const isLoading = ref(false);
    const isLoaded = ref(false);
    const fetchChannels = (constraints: Record<string, any>, extraFields?: string[]): void => {
        isLoading.value = true;
        if (!extraFields) {
            extraFields = [];
        }
        axios
            .get<ChannelInterface[]>("channels", {
                params: {
                    fields: `id,name,provider,platform${extraFields.length ? "," : ""}${extraFields.join(",")}`,
                    sort: "name,ASC",
                    s: constraints,
                },
            })
            .then((response) => {
                channels.value = response.data;
                isLoading.value = false;
                isLoaded.value = true;
            });
    };

    return {
        channels,
        isLoading,
        isLoaded,

        // Methods
        fetchChannels,
    };
}
